import React from 'react'
import { Box } from '@mui/material'
import OpenInNewIcon from '@mui/icons-material/OpenInNew'

import { formatMoney } from '../../../helpers/utils'
import {
  METRIC_TABLE_DIFFERENCE_BADGE_ICON_SX,
  getMetricTableClickableDifferenceBadgeSx,
  getMetricTableDifferenceBadgeSx
} from '../style/metricTableStyles'

const DifferenceBadge = ({ amount, clickable = false, label, onClick }) => {
  if (!amount) return '-'

  if (clickable) {
    return (
      <Box
        component="button"
        type="button"
        aria-label={label}
        onClick={onClick}
        sx={getMetricTableClickableDifferenceBadgeSx(amount)}
      >
        <OpenInNewIcon sx={METRIC_TABLE_DIFFERENCE_BADGE_ICON_SX} />
        {formatMoney(amount)}
      </Box>
    )
  }

  return (
    <Box component="span" sx={getMetricTableDifferenceBadgeSx(amount)}>
      {formatMoney(amount)}
    </Box>
  )
}

export default DifferenceBadge
